import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class LostModelService {

 constructor(private ws: PostmethodService) { }

  lostModelCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "lostModelMaster");
  }

  getOem(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "oemCompetitorMaster");
  }
}
